import React, { PureComponent } from "react";

import { toast } from "react-toastify";

import { Popover, OverlayTrigger } from "react-bootstrap";
import { Button, ButtonGroup, Dropdown } from "aible";

import { isEnabled } from "utils/featureFlags";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import SalesforceLogo from "images/datasource-sf.png";
import TableauLogo from "images/tableau.png";
import FileLogo from "images/csv.svg";

import styles from "./style.module.css";

export default class ProjectDeployment extends PureComponent {
  constructor(props) {
    super(props);

    this.state = { isCreatingDataset: false };
  }

  getCURL(deployment) {
    return `curl --request POST \\
  --url ${deployment.endpoint_url} \\
  --header 'content-type: application/json' \\
  ${Object.keys(deployment.endpoint_headers || {}).map(
    (key) => `--header '${key}: ${deployment.endpoint_headers[key]}' \\`
  )}
  --data '{"data":"FIELD_1,FIELD_2,FIELD_3\\nVALUE_1,VALUE_2,VALUE_3"}'
`;
  }

  getPython(deployment) {
    const headers = {
      "content-type": "application/json",
      ...(deployment.endpoint_headers || {})
    };

    const headersString = Object.keys(headers)
      .map((key) => `\n  '${key}': "${headers[key]}"`)
      .join(",");

    return `import time
import requests
import pandas as pd
from io import StringIO

input_df = # some pandas data frame

payload = {"data": input_df.to_csv()}

headers = {${headersString}
}

url = "${deployment.endpoint_url}"

r = requests.post(url, headers=headers, json=payload)

if r.status_code == 202:
    response = r.json()
else:
    raise ValueError(f"{r.status_code}: request failed")

while response["status"] == "INPROGRESS":
    time.sleep(2)

    r = requests.post(response["url"], headers=headers, json="")

    if r.status_code == 200:
        response = r.json()
    else:
        raise ValueError(f"{r.status_code}: request failed")

df = pd.read_csv(StringIO(response["predictions"]))`;
  }

  render() {
    const {
      deployment,
      isScoringFile,
      goToTableauHelp,
      goToSalesforceHelp,
      scoreFile,
      createDatasetFromMonitor,
      accountAPIEndpoint,
      id
    } = this.props;

    const { isCreatingDataset } = this.state;

    if (!deployment) {
      return (
        <div className={styles.deploy + " " + styles.deployed}>
          <div className={styles.deployHeader} style={{ fontSize: "24px", marginBottom: "40px" }}>
            {"No deployment found! Please deploy a scenario."}
          </div>
        </div>
      );
    }

    const isError = !deployment || deployment.status === "ERROR";
    const isDeploying = deployment && !deployment.endpoint_url;

    const headerText = isDeploying
      ? "Setting up your project for integration..."
      : "Your project is ready to be integrated!";

    return (
      <div className={styles.deploy + " " + styles.deployed}>
        <div className={styles.deployHeader} style={{ fontSize: "24px", marginBottom: "40px" }}>
          {headerText}
        </div>
        <div className={styles.deployFlex}>
          <div className={styles.deployLeft}>
            <div>
              <div className={styles.deployHeader}>{"Pre-Built Integrations"}</div>
              <div className={styles.deploySubHeader}>
                {"Get up and running with predictions by using our pre-built integrations."}
              </div>
            </div>
            <div className={styles.deployBoxHolder}>
              <div className={styles.deployBox}>
                <img src={TableauLogo} className={styles.deployIcon} />
                <div className={styles.deployBoxHeader}>{"Tableau"}</div>
                <div className={styles.deployBoxContent}>
                  {"View What-if scenarios and predictions based on your dashboard data"}
                </div>
                <a onClick={() => goToTableauHelp()}>{"Learn More"}</a>
              </div>
              <div className={styles.deployBox}>
                <img src={SalesforceLogo} className={styles.deployIcon} />
                <div className={styles.deployBoxHeader}>{"Salesforce"}</div>
                <div className={styles.deployBoxContent}>
                  {"See predictions in context while viewing a record in Salesforce"}
                </div>
                {/* <a onClick={() => goToSalesforceHelp()}>{"Learn More"}</a> */}
                {/* TODO: GET A BETTER LINK THANK THIS GROSS EMAIL */}
                <div>
                  {"Contact us at "}
                  <a href="mailto:success@aible.com">success@aible.com</a>
                </div>
              </div>

              {isEnabled("hide-bulk-scoring") === true ? (
                <div />
              ) : (
                <div className={styles.deployBox}>
                  <img src={FileLogo} className={styles.deployIcon} />
                  <div className={styles.deployBoxHeader}>{"CSV Bulk Scoring"}</div>
                  <div className={styles.deployBoxContent}>
                    {"Make predictions directly to all records in a CSV file."}
                  </div>
                  <input
                    id="fileSelect"
                    type="file"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    onChange={(e) => {
                      scoreFile(e.target.files[0]);
                      document.getElementById("fileSelect").value = "";
                    }}
                    style={{ visibility: "hidden", height: "0px" }}
                  />

                  {isScoringFile ? (
                    <div>
                      <LoadingIndicator />
                      {"Scoring File..."}
                    </div>
                  ) : (
                    <a onClick={() => document.getElementById("fileSelect").click()}>{"Click here to score a file"}</a>
                  )}
                </div>
              )}
            </div>
          </div>
          {isError ? (
            <div className={styles.deployRight}>
              <div className={styles.loading}>
                <div className={styles.loadMsg}>{"Deployment Error"}</div>
                <div className={styles.deploySubHeader}>{"Please try again or contact us for support"}</div>
              </div>
            </div>
          ) : isDeploying ? (
            <div className={styles.deployRight}>
              <div className={styles.loading}>
                <LoadingIndicator
                  style={{
                    margin: "0px",
                    marginTop: "-25vh",
                    marginBottom: "50px",
                    transform: "scale(1.75)"
                  }}
                />
                <div className={styles.loadMsg}>{"Deploying Project"}</div>
                <div className={styles.deploySubHeader}>{"This will take up to 5 minutes..."}</div>
              </div>
            </div>
          ) : (
            <div className={styles.deployRight}>
              <div>
                <div className={styles.deployHeader}>{"Custom Integrations"}</div>
                <div className={styles.deploySubHeader}>{"Add predictions to your app and data pipelines!"}</div>
                <div className={styles.deployCustomItem}>
                  <div className={styles.deployBoxHeader}>{"REST API"}</div>
                  <div className={styles.deployBoxContent}>
                    {"Generate predictions from anywhere using the Aible Predict REST API."}
                  </div>
                  <div className={styles.deployButtons}>
                    <ButtonGroup>
                      <OverlayTrigger
                        placement="top"
                        trigger="click"
                        rootClose
                        overlay={
                          <Popover id="popover-positioned-top" title="Endpoint URL and Headers">
                            <div className={styles.popList}>
                              {accountAPIEndpoint ? (
                                <React.Fragment>
                                  <div className={styles.apiHeadersLabel}>{"URL"}</div>
                                  <div>{`${accountAPIEndpoint}/v1/scores/projects/${id}`}</div>
                                  <div className={styles.apiHeadersLabel}>{"Authorization"}</div>
                                  This url supports basic authentication and requires a valid aible login that has
                                  permissions to access this project.
                                </React.Fragment>
                              ) : (
                                ""
                              )}
                            </div>
                          </Popover>
                        }
                      >
                        <Button>{"View API Endpoint"}</Button>
                      </OverlayTrigger>
                    </ButtonGroup>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
